export function auditoriaSistema(registro) {
  try {
    const dato = typeof registro.descripcion === 'string'
      ? JSON.parse(registro.descripcion) : registro.descripcion;
    return dato && !Array.isArray(dato) && dato.sistema === true ? dato : null;
  } catch { return null; }
}

export function esActorSistema(registro) {
  return registro.actor_type === 'sistema' || Boolean(auditoriaSistema(registro));
}

const campos = {
  institucion: 'Lugar', lugar: 'Lugar', departamento: 'Departamento', ciudad: 'Ciudad',
  localidad: 'Localidad', barrio: 'Barrio', vereda_corregimiento: 'Vereda o corregimiento',
  direccion: 'Dirección', indicaciones: 'Indicaciones', wkt: 'Coordenadas',
};
const valor = (dato) => dato === null || dato === undefined || dato === ''
  ? 'Sin información' : String(dato);

export function descripcionHistorial(registro) {
  const dato = auditoriaSistema(registro);
  if (!dato || !dato.antes || !dato.despues || typeof dato.antes !== 'object' ||
      typeof dato.despues !== 'object' || Array.isArray(dato.antes) || Array.isArray(dato.despues)) {
    return typeof registro.descripcion === 'string' ? registro.descripcion : '';
  }
  const lineas = ['El sistema corrigió los datos de ubicación.'];
  if (dato.trayecto === 'Ida' || dato.trayecto === 'Retorno') lineas.push(`Trayecto: ${dato.trayecto}.`);
  if (Array.isArray(dato.traslados_corregidos)) {
    const cantidad = dato.traslados_corregidos.length;
    lineas.push(`Traslados asociados corregidos: ${cantidad}.`);
  }
  for (const lado of ['origen', 'destino']) {
    const cambios = Object.entries(campos).flatMap(([campo, etiqueta]) => {
      const clave = `${lado}_${campo}`;
      if (!Object.prototype.hasOwnProperty.call(dato.despues, clave) || dato.antes[clave] === dato.despues[clave]) return [];
      return [`${etiqueta}: ${valor(dato.antes[clave])} → ${valor(dato.despues[clave])}`];
    });
    if (cambios.length) lineas.push('', lado === 'origen' ? 'Origen — Antes → Después' : 'Destino — Antes → Después', ...cambios);
  }
  return lineas.join('\n');
}
